import React from 'react';
import { Button } from '../../../components/ui/button';
import { Badge } from '../../../components/ui/badge';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '../../../components/ui/dialog';

export const AssignClientTypeDialog = ({ open, onOpenChange, clientTypes, selectedClient, onAssign }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Assign Client Type</DialogTitle>
        <DialogDescription>Select a pricing tier for {selectedClient?.company_name}</DialogDescription>
      </DialogHeader>

      <div className="space-y-3 py-4">
        {clientTypes.filter((t) => t.is_active).map((type) => (
          <div
            key={type.id}
            className={`p-4 border rounded-lg cursor-pointer transition-colors hover:border-amber-500 ${
              selectedClient?.client_type_id === type.id ? 'border-amber-500 bg-amber-50' : ''
            }`}
            onClick={() => onAssign(selectedClient.id, type.id)}
            data-testid={`assign-type-option-${type.id}`}
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="font-medium">{type.name}</p>
                <p className="text-sm text-gray-500">{type.description}</p>
              </div>
              <div className="text-right">
                <p className="text-lg font-bold text-amber-600">{type.default_discount_percent}% off</p>
                {type.has_guaranteed_returns && (
                  <Badge className="bg-green-100 text-green-800 text-xs">Returns OK</Badge>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
